'use client';

import { logger } from '@magicschool/logger';
import { useStore } from 'features/store';
import type { UserRole } from '@/features/server/actions/rbac/types';
import { getUserAgeDays } from '@/util/amplitude/util';
import { MILLISECONDS_IN_DAY } from '@/util/date';

export const useAuth = () => {
  const { session, ...rest } = useStore(
    ({ AuthStoreData: as }) => ({
      ...as,
    }),
    [],
  );

  return {
    ...rest,
    session,
    get supabaseUser() {
      return session;
    },
    get isSignedIn(): boolean {
      return !!session?.id;
    },
    get userId(): string {
      return session?.id ?? '';
    },
    get orgId(): string {
      return rest.userData.org_id ?? '';
    },
    get userEmail(): string {
      return rest.userData.email ?? '';
    },
    get userName(): string {
      return rest.userData.name ?? rest.userData.email ?? '';
    },
    get planId(): number {
      return rest.userData.plan ?? 1;
    },
    get userRole(): UserRole {
      return rest.userData.user_role ?? 'teacher';
    },
    get userAttributes() {
      return rest.userAttributes ?? [];
    },
    get orgAttributes() {
      return rest.orgAttributes ?? [];
    },
    get orgToolAccessOverrides() {
      return rest.orgToolAccessOverrides ?? [];
    },
    get userToolAccessOverrides() {
      return rest.userToolAccessOverrides ?? [];
    },
    get userAgeDays() {
      try {
        return getUserAgeDays(rest.userData.created_at);
      } catch (e: any) {
        logger.error("Error determining user's account age", e);
      }
      return 0;
    },
    get isNew() {
      if (!rest.userData.created_at) return false;

      // Only return true if the user has been created in the last 14 days
      const isNew = new Date(rest.userData.created_at) > new Date(new Date().getTime() - 14 * MILLISECONDS_IN_DAY);

      return isNew;
    },
    get passABTest() {
      return rest.userData.serial_id % 2 === 0;
    },
    get lms() {
      return rest.lms;
    },
    get userTrials() {
      return rest.userTrials ?? [];
    },
  };
};
